import React,{useState,useEffect} from 'react'
import { app } from '../../Firebase/Firebaseapp';
import { getStorage, getDownloadURL, ref } from "firebase/storage";


const fireStorage = getStorage(app);

const BrandCard = ({x,index,reRender}) => {

    const [GetImage, setGetImage] = useState("");

    const getBrandImg =(path) => {
        return  getDownloadURL(ref(fireStorage, path))
      }
  

    useEffect(() => {
     
         getBrandImg(x.data().BrandLogo).then((url) => setGetImage(url))
       
      
       console.log("I  am Addbrand")
 
   }, [reRender])


  return (
    <tr key={x.data().id}>
    <td class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-left">
    {index+1}
    </td>
    <td class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-left">
      <div class="flex items-center">
                              <div class="flex-shrink-0 w-12 h-12">
                                  <img class="w-full h-full rounded-full"
                                      src={GetImage}
                                      alt="" />
                              </div>
                              
                          </div>
    </td>

  
    <td class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-left">
    <div className="bg-[crimson] hover:bg-blue-700 text-white font-bold p-2 text-lg rounded-full text-center">
    {x.data().Brand}
    </div>
    </td>

  
  </tr>
  )
}

export default BrandCard